/**
 * Detect browser and OS information from user agent
 */
export function getBrowserInfo() {
    const userAgent = navigator.userAgent;
    let browser = 'Unknown';
    let os = 'Unknown';
    // Detect Browser
    if (userAgent.indexOf('Firefox') > -1) {
        browser = 'Firefox';
    }
    else if (userAgent.indexOf('Edg') > -1) {
        browser = 'Edge';
    }
    else if (userAgent.indexOf('Chrome') > -1) {
        browser = 'Chrome';
    }
    else if (userAgent.indexOf('Safari') > -1) {
        browser = 'Safari';
    }
    else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
        browser = 'Opera';
    }
    else if (userAgent.indexOf('Trident') > -1) {
        browser = 'IE';
    }
    // Detect OS
    if (userAgent.indexOf('Win') > -1) {
        os = 'Windows';
    }
    else if (userAgent.indexOf('Mac') > -1) {
        os = 'MacOS';
    }
    else if (userAgent.indexOf('Linux') > -1) {
        os = 'Linux';
    }
    else if (userAgent.indexOf('Android') > -1) {
        os = 'Android';
    }
    else if (userAgent.indexOf('iOS') > -1 || userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1) {
        os = 'iOS';
    }
    return { browser, os };
}
